import React from "react"

const monthdata = [
    {
        id: 0,
        value: "Dec"
    },    {
        id: 1,
        value: "Jan"
    },
]

export default monthdata;
